(() => {
  const headers = document.querySelectorAll('[data-rk-header]');

  headers.forEach((header) => {
    const toggle = header.querySelector('[data-rk-drawer-toggle]');
    const drawer = header.querySelector('[data-rk-drawer]');
    const overlay = header.querySelector('[data-rk-drawer-overlay]');
    const closeButtons = header.querySelectorAll('[data-rk-drawer-close]');
    const drawerLinks = header.querySelectorAll('[data-rk-drawer-link]');
    const mobileCart = header.querySelector('[data-rk-mobile-cart]');
    const stickyEnabled = header.classList.contains('rk-header--sticky');

    if (!toggle || !drawer || !overlay) return;

    let lastFocused = null;
    let stickyStart = 0;

    const syncStickyMetrics = () => {
      if (!stickyEnabled) return;

      header.classList.remove('is-stuck');
      const section = header.closest('.section-header');
      if (section) section.style.setProperty('--rk-sticky-header-height', `${header.offsetHeight}px`);

      stickyStart = header.getBoundingClientRect().top + window.scrollY;
      syncStickyState();
    };

    const syncStickyState = () => {
      if (!stickyEnabled) return;
      header.classList.toggle('is-stuck', window.scrollY >= stickyStart);
    };

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const getFocusable = () => Array.from(drawer.querySelectorAll(focusableSelector));

    const openDrawer = () => {
      lastFocused = document.activeElement;
      header.classList.add('is-drawer-open');
      document.body.classList.add('rk-drawer-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');

      const closeButton = drawer.querySelector('[data-rk-drawer-close]');
      if (closeButton) closeButton.focus();
    };

    const closeDrawer = () => {
      header.classList.remove('is-drawer-open');
      document.body.classList.remove('rk-drawer-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    toggle.addEventListener('click', () => {
      if (header.classList.contains('is-drawer-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    overlay.addEventListener('click', closeDrawer);
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawerLinks.forEach((link) => link.addEventListener('click', closeDrawer));

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (mobileCart) {
      mobileCart.addEventListener('click', (event) => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
        event.preventDefault();
        cartDrawer.open(mobileCart);
      });
    }

    if (stickyEnabled) {
      syncStickyMetrics();
      window.addEventListener('scroll', syncStickyState, { passive: true });
      window.addEventListener('resize', syncStickyMetrics);
    }
  });
})();
